export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';


// WEBPACK FOOTER //
// ./src/core/modal/action-types.js